import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "search-results" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "search-results__title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "hide-mobile" }, [
  /*#__PURE__*/_createVNode("strong", null, "Tip:"),
  /*#__PURE__*/_createTextVNode(" Use \"Up\" & \"Down\" arrows keys to navigate. ")
], -1)
const _hoisted_7 = { class: "search-results-item" }
const _hoisted_8 = { class: "search-results-item__description" }
const _hoisted_9 = { key: 3 }

export function render(_ctx, _cache) {
  const _component_base_list = _resolveComponent("base-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "slide-in-left",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!_ctx.keyword.length)
          ? (_openBlock(), _createBlock("p", _hoisted_2, "Type something to start searching."))
          : (_ctx.keyword.length < 3)
            ? (_openBlock(), _createBlock("p", _hoisted_3, " Search terms must be at least 3 characters long. "))
            : (_ctx.items.length)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("h4", _hoisted_5, "Found " + _toDisplayString(_ctx.items.length) + " matches.", 1),
                  _hoisted_6,
                  _createVNode(_component_base_list, {
                    class: "search-results-list",
                    items: _ctx.items
                  }, {
                    default: _withCtx(({ item }) => [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("a", {
                          class: "search-results-item__title",
                          href: item.url,
                          onClick: $event => (_ctx.$emit('on-item-navigate', item.id))
                        }, _toDisplayString(item.title), 9, ["href", "onClick"]),
                        _createVNode("p", _hoisted_8, _toDisplayString(item.description), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_9, "No matches were found."))
      ]),
      _: 1
    })
  ]))
}

  import BaseList from "./BaseList.vue"

  /**
   * SearchResults component props.
   * @typedef {Object} SearchResultsProps
   * @property {string} keyword Search term
   * @property {SearchReferenceItem[]} items List of search results
   */

  export default {
    name: "search-results",
    /**
     * @type {SearchResultsProps}
     */
    props: {
      keyword: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
    },
    emits: {
      // When search result item link is being navigated to
      "on-item-navigate": (id) => typeof id === "string",
    },
    components: {
      BaseList,
    },
  }
